import { FormControl, Validators } from '@angular/forms';
import { ibanValidator, SubmittableForm } from '@fino-ui/forms';

export const REJECTION_REASONS = {
  OK: 'OK',
  NEEDS_CLARIFICATION: 'NEEDS_CLARIFICATION',
  NEW_IBAN_MISSING: 'NEW_IBAN_MISSING',
  INCOMPLETE_WITHOUT_IBAN: 'INCOMPLETE_WITHOUT_IBAN',
  UNREADABLE_WITH_IBAN: 'UNREADABLE_WITH_IBAN',
  INCOMPLETE_WITH_IBAN: 'INCOMPLETE_WITH_IBAN',
  OTHER: 'OTHER',
};

enum DOCUMENT_TYPES {
  WARRANT,
  BALANCE_LIST,
  REJECTED_BALANCE_LIST,
  REJECTED_WARRANT,
  ADMONITION_BALANCE_LIST,
  MISC,
}

export const REJECTION_REASONS_HIDDEN_FOR_DOCUMENT_TYPES = [
  DOCUMENT_TYPES[DOCUMENT_TYPES.REJECTED_BALANCE_LIST],
  DOCUMENT_TYPES[DOCUMENT_TYPES.REJECTED_WARRANT],
];

export const REJECTION_REASONS_GENERAL = [
  {
    value: REJECTION_REASONS.OK,
    higlightedBy: [REJECTION_REASONS.OK],
    translation: 'OK',
    icon: 'Like',
  },
  {
    value: REJECTION_REASONS.NEEDS_CLARIFICATION,
    higlightedBy: [REJECTION_REASONS.NEEDS_CLARIFICATION],
    translation: 'NEEDS_CLARIFICATION',
    icon: 'Saving Bank 1',
  },
  {
    value: REJECTION_REASONS.OTHER,
    hiddenWhenDocumentType: REJECTION_REASONS_HIDDEN_FOR_DOCUMENT_TYPES,
    higlightedBy: [
      REJECTION_REASONS.NEW_IBAN_MISSING,
      REJECTION_REASONS.INCOMPLETE_WITHOUT_IBAN,
      REJECTION_REASONS.UNREADABLE_WITH_IBAN,
      REJECTION_REASONS.INCOMPLETE_WITH_IBAN,
      REJECTION_REASONS.OTHER,
      'ELSE',
    ],
    translation: 'ELSE',
    icon: 'Dislike',
  },
];

export const REJECTION_REASONS_DETAILED = [
  REJECTION_REASONS.NEW_IBAN_MISSING,
  REJECTION_REASONS.INCOMPLETE_WITHOUT_IBAN,
  REJECTION_REASONS.UNREADABLE_WITH_IBAN,
  REJECTION_REASONS.INCOMPLETE_WITH_IBAN,
  REJECTION_REASONS.OTHER,
];

export const DOCUMENT_TYPES_BUTTONS = [
  {
    type: DOCUMENT_TYPES[DOCUMENT_TYPES.WARRANT],
    isOldBank: true,
  },
  {
    type: DOCUMENT_TYPES[DOCUMENT_TYPES.BALANCE_LIST],
    isOldBank: false,
  },
  {
    type: DOCUMENT_TYPES[DOCUMENT_TYPES.REJECTED_BALANCE_LIST],
    isOldBank: true,
  },
  {
    type: DOCUMENT_TYPES[DOCUMENT_TYPES.REJECTED_WARRANT],
    isOldBank: false,
  },
  {
    type: DOCUMENT_TYPES[DOCUMENT_TYPES.ADMONITION_BALANCE_LIST],
    isOldBank: true,
  },
  {
    type: DOCUMENT_TYPES[DOCUMENT_TYPES.MISC],
    isOldBank: false,
  },
];

export const IdentifyDocumentForm = new SubmittableForm({
  tenant: new FormControl('', Validators.required),
  documentType: new FormControl('', Validators.required),
  oldIban: new FormControl('', [Validators.required, ibanValidator]),
  newIban: new FormControl('', [Validators.required, ibanValidator]),
  rejectionReason: new FormControl('', Validators.required),
  rejectionReasonText: new FormControl(''),
});
